import { customIconFileNames } from "./customIconManifest.generated";
import { getMapEntityTypeLabel } from "../../../constants/mapEntityIcons";

const entityTypeGroups = {
  group1: ["Marker", "CustomIcon", "Circle"],
  group2: ["Polygon", "Polyline"],
  group3: ["REGION"],
};

const sizeOptions = [
  { value: "Small", label: "Small" },
  { value: "Standard", label: "Standard" },
  { value: "Large", label: "Large" },
];

/** Shared picker options: import modals, toolbar, edit, templates. */
const customIconOptions = customIconFileNames.map((file) => ({ file }));

const prettifyFieldLabelMap = {
  entityType: "Entity Type",
  title: "Entity Title",
  label: "Entity Title",
  fillColor: "Fill Color",
  fillOpacity: "Fill Opacity",
  strokeColor: "Stroke Color",
  strokeOpacity: "Stroke Opacity",
  strokeWeight: "Stroke Weight",
  lineStyle: "Line Style",
  iconUrl: "Icon URL",
  customIcon: "Pin",
};

const getEntityTypeOptions = (currentEntityType) => {
  if (entityTypeGroups.group1.includes(currentEntityType)) {
    return entityTypeGroups.group1;
  }
  if (entityTypeGroups.group2.includes(currentEntityType)) {
    return entityTypeGroups.group2;
  }
  if (entityTypeGroups.group3.includes(currentEntityType)) {
    return entityTypeGroups.group3;
  }
  return [];
};

const getDefaultAttributes = (entityType) => {
  switch (entityType) {
    case "Marker":
      return { size: "Standard" };
    case "CustomIcon":
      return { size: "Standard", iconUrl: "" };
    case "Polygon":
    case "REGION":
      return {
        fillColor: "#FF0000",
        fillOpacity: 0.5,
        strokeColor: "#FF0000",
        strokeOpacity: 0.6,
        strokeWeight: 2,
      };
    case "Polyline":
      return {
        strokeColor: "#0000FF",
        strokeOpacity: 1.0,
        strokeWeight: 3,
      };
    case "Circle":
      return {
        radius: 100,
        fillColor: "#FF0000",
        fillOpacity: 0.5,
        strokeColor: "#FF0000",
        strokeOpacity: 0.6,
        strokeWeight: 2,
      };
    default:
      return {};
  }
};

const prettifyFieldName = (fieldName) => {
  if (prettifyFieldLabelMap[fieldName]) return prettifyFieldLabelMap[fieldName];
  const withSpaces = String(fieldName || "").replace(/([a-z])([A-Z])/g, "$1 $2");
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
};

const prettifyEntityType = (entityType) => {
  const raw = String(entityType || "").trim();
  if (!raw) return "";
  return getMapEntityTypeLabel(raw);
};

export {
  customIconFileNames,
  customIconOptions,
  getDefaultAttributes,
  getEntityTypeOptions,
  prettifyEntityType,
  prettifyFieldName,
  sizeOptions,
};
